import { Box, Loader } from 'ui';

export const LoaderView = () => (
  <Box display="flex" justifyContent="center" alignItems="center" height="100%">
    <Loader />
  </Box>
);
